import * as React from 'react'

export function Progress({ value = 0, indicatorColor, className }) {
  return (
    <div className={`w-full h-2 bg-slate-200 rounded ${className || ''}`}>
      <div
        className={`h-2 rounded transition-all duration-500 ${indicatorColor || 'bg-blue-600'}`}
        style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
      />
    </div>
  )
}